<div class="customPanel">
  <h1 *ngIf="type == 'lum' || type == 'lum-batch'" class="textM" style="text-align: center; height: 7%" mat-dialog-title>
    {{this.localiser.get("devices.delete.lum")}}
  </h1>
  <h1 *ngIf="type == 'gw'" class="textM" style="text-align: center; height: 7%" mat-dialog-title>
    {{this.localiser.get("devices.delete.gw")}}
  </h1>
  <h1 *ngIf="type == 'sensor'" class="textM" style="text-align: center; height: 7%" mat-dialog-title>
    {{this.localiser.get("devices.delete.sensor")}}
  </h1>

  <div *ngIf="(type == 'lum' || type == 'lum-batch') && !deleteLumRegistry && !deleteLumFull" mat-dialog-content class="bodyForm">

    <h1 *ngIf="type == 'lum'" class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      {{this.localiser.get("devices.name")}}: {{device.nombre}}
    </h1>

    <h1 *ngIf="type == 'lum'" class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      ID: {{device.idDispositivo}}
    </h1>

    <h1 *ngIf="type == 'lum-batch'" class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      {{this.localiser.get("devices.delete.batchDeleteSearchResults")}}
    </h1>

    <h1 *ngIf="type == 'lum-batch'" class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      {{this.localiser.get("devices.delete.matchingLuminaries")}}: {{getBatchDeleteCount()}}
    </h1>

    <div class="row" style="height: 70%">

      <div class="col-6 deleteButtonOut" (click)="changeRegistryDelete()">
        <div class="deleteButtonIn">
          <div style="height: 30%">
            <h1 class="textM centerVert deleteHeaderText">
              {{this.localiser.get("devices.delete.registryDelete")}}
            </h1>
          </div>
          <div class="deleteParrDiv">
            <p class="textS+">{{this.localiser.get("devices.delete.registryDeleteInfo")}}</p>
          </div>
        </div>
      </div>

      <div class="col-6 deleteButtonOut" (click)="changeFullDelete()">
        <div class="deleteButtonIn">
          <div style="height: 30%">
            <h1 class="textM centerVert deleteHeaderText">
              {{this.localiser.get("devices.delete.fullDelete")}}
            </h1>
          </div>
          <div class="deleteParrDiv">
            <p class="textS+">{{this.localiser.get("devices.delete.fullDeleteInfo")}}</p>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div *ngIf="(type == 'lum' || type == 'lum-batch') && (deleteLumRegistry || deleteLumFull)" mat-dialog-content class="bodyForm">

    <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      {{this.localiser.get(type == 'lum-batch' ? "devices.delete.sureDeleteLumBatch" : "devices.delete.sureDeleteLum")}}:
    </h1>

    <h1 *ngIf="type == 'lum'" class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      {{this.localiser.get("devices.name")}}: {{device.nombre}}
    </h1>

    <h1 *ngIf="type == 'lum'" class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      ID: {{device.idDispositivo}}
    </h1>

    <h1 *ngIf="type == 'lum-batch'" class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      {{this.localiser.get("devices.delete.matchingLuminaries")}}: {{getBatchDeleteCount()}}
    </h1>

    <div class="row" style="height: 50%">

      <div class="col deleteInfoOut">
        <div class="deleteInfoIn">
          <div style="height: 30%">
            <h1 *ngIf="deleteLumRegistry" class="textM centerVert deleteHeaderText">
              {{this.localiser.get("devices.delete.registryDelete")}}
            </h1>
            <h1 *ngIf="deleteLumFull" class="textM centerVert deleteHeaderText">
              {{this.localiser.get("devices.delete.fullDelete")}}
            </h1>
          </div>
          <div class="deleteParrDiv">
            <p *ngIf="deleteLumRegistry" class="textS+">{{this.localiser.get("devices.delete.registryDeleteInfo")}}</p>
            <p *ngIf="deleteLumFull" class="textS+">{{this.localiser.get("devices.delete.fullDeleteInfo")}}</p>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div *ngIf="type == 'gw' && !deleteGW" mat-dialog-content class="bodyForm">

    <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      {{this.localiser.get("devices.name")}}: {{device.nombre}}
    </h1>

    <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      ID: {{device.idDispositivo}}
    </h1>

    <div class="row" style="height: 70%">

      <div class="col-6 deleteButtonOut" (click)="changeGWDelete()">
        <div class="deleteButtonIn">
          <div style="height: 30%">
            <h1 class="textM centerVert deleteHeaderText">
              {{this.localiser.get("devices.delete.gw")}}
            </h1>
          </div>
          <div class="deleteParrDiv">
            <p class="textS+">{{this.localiser.get("devices.delete.gwDeleteInfo")}}</p>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div *ngIf="type == 'gw' && deleteGW" mat-dialog-content class="bodyForm">

    <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      {{this.localiser.get("devices.delete.sureDeleteGW")}}:
    </h1>

    <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      {{this.localiser.get("devices.name")}}: {{device.nombre}}
    </h1>

    <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      ID: {{device.idDispositivo}}
    </h1>

    <div class="row" style="height: 50%">

      <div class="col deleteInfoOut">
        <div class="deleteInfoIn">
          <div style="height: 30%">
            <h1 class="textM centerVert deleteHeaderText">
              {{this.localiser.get("devices.delete.gw")}}
            </h1>
          </div>
          <div class="deleteParrDiv">
            <p class="textS+">{{this.localiser.get("devices.delete.gwDeleteInfo")}}</p>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div *ngIf="type == 'sensor' && !deleteSensor" mat-dialog-content class="bodyForm">

    <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      {{this.localiser.get("devices.name")}}: {{device.nombre}}
    </h1>

    <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      ID: {{device.idLuminaria}}
    </h1>

    <div class="row" style="height: 70%">

      <div class="col-6 deleteButtonOut" (click)="changeSensorDelete()">
        <div class="deleteButtonIn">
          <div style="height: 30%">
            <h1 class="textM centerVert deleteHeaderText">
              {{this.localiser.get("devices.delete.sensor")}}
            </h1>
          </div>
          <div class="deleteParrDiv">
            <p class="textS+">{{this.localiser.get("devices.delete.sensorDeleteInfo")}}</p>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div *ngIf="type == 'sensor' && deleteSensor" mat-dialog-content class="bodyForm">

    <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      {{this.localiser.get("devices.delete.sureDeleteSensor")}}:
    </h1>

    <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      {{this.localiser.get("devices.name")}}: {{device.nombre}}
    </h1>

    <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
      ID: {{device.idLuminaria}}
    </h1>

    <div class="row" style="height: 50%">

      <div class="col deleteInfoOut">
        <div class="deleteInfoIn">
          <div style="height: 30%">
            <h1 class="textM centerVert deleteHeaderText">
              {{this.localiser.get("devices.delete.sensor")}}
            </h1>
          </div>
          <div class="deleteParrDiv">
            <p class="textS+">{{this.localiser.get("devices.delete.sensorDeleteInfo")}}</p>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div mat-dialog-actions>
    <div class="col" *ngIf="!deleting" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="onCancelClick()">{{this.localiser.get("devices.cancel")}}</button>
    </div>

    <div class="col" *ngIf="!deleting && (deleteLumRegistry || deleteLumFull || deleteGW || deleteSensor)" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="goBack()">{{this.localiser.get("button.back")}}</button>
    </div>

    <div class="col" *ngIf="!deleting && (deleteLumRegistry || deleteLumFull || deleteGW || deleteSensor)" style="text-align: center">
      <button class="customButtonColorDelete textS+" mat-button (click)="confirmDelete()">{{this.localiser.get("button.delete")}}</button>
    </div>

    <div class="col" *ngIf="deleting" style="text-align: center">
      <mat-progress-spinner class="spinner" color="primary" mode="indeterminate" diameter="40">
      </mat-progress-spinner>
    </div>

  </div>


</div>
